import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
  <h1 style={{ fontSize: "2.6em" }}>
    👋 <span className="purple">Let Me Introduce Myself</span>
  </h1>
  <p className="home-about-body">
    I’m a passionate programmer who loves exploring and building{" "}
    <b className="purple">modern web technologies</b>. Over time, I have
    developed strong expertise in{" "}
    <b className="purple">JavaScript</b> and full-stack development.
    <br />
    <br />
    <b className="purple">💡 What I Do</b>
    <br />⚡ Build dynamic web applications with{" "}
    <b className="purple">JavaScript</b>
    <br />⚛️ Craft interactive UIs using{" "}
    <b className="purple">React.js</b>
    <br />🌐 Develop full-stack solutions with{" "}
    <b className="purple">MERN Stack (MongoDB, Express.js, React.js, Node.js)</b>
    <br />⛓️ Explore{" "}
    <b className="purple">Blockchain technologies</b> and their real-world applications
    <br />
    <br />
    <b className="purple">🎯 Goals</b>
    <br />
    I aim to create impactful products and solutions by combining my
    skills with the latest tools and technologies.
    <br />
    <br />
    <b className="purple">🛠️ Tech Stack</b>
    <br />- Languages: JavaScript
    <br />- Frontend: React.js, Tailwind CSS
    <br />- Backend: Node.js, Express.js
    <br />- Database: MongoDB
    <br />- Others: MERN Stack, Git, APIs, Blockchain basics
  </p>
</Col>

<Col md={4} className="myAvtar">
  <Tilt>
    <img src={myImg} className="img-fluid" alt="avatar" />
  </Tilt>
</Col>

        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/AhtishamUrRehman"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://x.com/EhteshamUrRehm2"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/rana-ehtisham-935115376"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/ranaehtesham951"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
